import React, { FC } from 'react';
import Sheet from '@mui/joy/Sheet';
import CircleIcon from '@mui/icons-material/Circle';
import GaugeComponent from '../ChartItems/GaugeComponent';
import useGetByStatus from '../../../../store/ReactQueries/dashboards/useGetByStatus';
import { cardStyle } from './TopChart';
import { darkModeBackgroud } from '../../../../utils/constants';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../../store/useLanguageStore';

interface TicketsByStatusesProp {
    height?: number;
    year: number;
}

const TicketsByStatuses: FC<TicketsByStatusesProp> = ({ height, year }) => {
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const upCardStyle = {
        ...cardStyle,
        py: 3,
        px: 4,
        height: height ? `${height}px` : '300px',
        background: darkMode ? darkModeBackgroud : 'white',
    }
    const { data } = useGetByStatus(year);

    return <Sheet sx={upCardStyle}>
        <h5 className='mb-0' style={{ color: darkMode ? "white" : 'rgba(50, 71, 92, 0.87)', opacity: .9 }}>{language['Statuses']}</h5>
        <hr className={darkMode ? 'text-white opacity-100' : ''} />
        <div className='d-flex flex-row align-items-center justify-content-center' style={{ width: '100%', height: '100%' }}>
            <div className='gauge-status-item'>
                <GaugeComponent data={data || []} />
            </div>
            <div className='d-flex flex-column gap-3 ticket-status-item pe-1'>
                {
                    data?.map(({ title, ticketCount, badgeColor }) =>
                        <div
                            key={title}
                            className='d-flex flex-row align-items-center'
                            style={{ color: badgeColor ?? '#8D97A0' }}
                        >
                            <span className='ticket-circle-item'>
                                <CircleIcon />
                            </span>
                            <span title={title} className='text-truncate' style={{ maxWidth: '100px' }}>{title}</span>
                            <span className='ms-auto'>{ticketCount}</span>
                        </div>)
                }
            </div>
        </div>
    </Sheet>
}
export default TicketsByStatuses;